var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        transition: "scroll-x-transition",
        "overlay-color": "grey darken-2",
        "content-class": "ec-confirmation-dialog",
        width: _vm.textBig ? 440 : 300,
        persistent: "",
      },
      model: {
        value: _vm.confirmDialog,
        callback: function ($$v) {
          _vm.confirmDialog = $$v
        },
        expression: "confirmDialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { color: "accent", width: _vm.textBig ? 440 : 300 } },
        [
          _c(
            "v-card-title",
            {
              staticStyle: { "background-color": "#47BD96", color: "white" },
              attrs: { dark: "" },
            },
            [_vm._v(" " + _vm._s(_vm.title) + " ")]
          ),
          _c("v-card-text", { staticClass: "pb-0 pt-5 text-center" }, [
            _c("p", { staticClass: "pt-1 ec-dialog-text" }, [
              _vm._v(_vm._s(_vm.text)),
            ]),
            _vm.text2.length
              ? _c(
                  "p",
                  {
                    staticClass: "ec-dialog-text red--text",
                    attrs: { color: "red" },
                  },
                  [_vm._v(_vm._s(_vm.text2))]
                )
              : _vm._e(),
          ]),
          _c(
            "v-card-actions",
            { staticClass: "pt-0" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("confirmation-event", false)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.cancelButton))]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: _vm.cantDelete ? "red" : "primary",
                    text: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("confirmation-event", true)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.acceptButton))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }